import {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	Typed,
	typed as typedCore
} from '@sage-js/core';

import {NAME} from './meta';

export const typed = typedCore.namespace(NAME);
